import { Col, Form, FormInstance, Row, Select, Radio, Divider } from 'antd'
import React, { FunctionComponent, useEffect } from 'react'
import { EeoOptions } from '../../../context/types'
import { useEeoContext } from '../../../context/eeo'
import './EEOInfo.less'

const { Option } = Select

type TProps = {
	form: FormInstance
}
const EEOInfo: FunctionComponent<TProps> = () => {
	const { eeo, actions: eeoActions } = useEeoContext()

	useEffect(() => {
		if (!eeo.genders.length || !eeo.ethnicities.length || !eeo.age_ranges.length) {
			eeoActions.allLists()
		}
	}, [])

	return (
		<Row className="eeo-info" gutter={[50, 0]}>
			<Col xs={24} lg={8}>
				<Form.Item name="eeo_age_range_id" label="My age range">
					<Select placeholder="My age range">
						{eeo.age_ranges.map(({ id, name }) => (
							<Option key={id} value={id}>
								{name}
							</Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item name="eeo_gender_id" label="I identify as">
					<Select placeholder="I identify as">
						{eeo.genders.map(({ id, name }) => (
							<Option key={id} value={id}>
								{name}
							</Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item name="eeo_ethnicity_id" label="My ethnicity">
					<Select placeholder="My ethnicity">
						{eeo.ethnicities.map(({ id, name }) => (
							<Option key={id} value={id}>
								{name}
							</Option>
						))}
					</Select>
				</Form.Item>
			</Col>
			<Col xs={24} lg={1}>
				<Divider className="desktop-divider" type="vertical" style={{ height: '100%' }} />
			</Col>
			<Col xs={24} lg={13}>
				<Row className="eeo-info" gutter={[50, 0]}>
					<Col xs={24} lg={12}>
						<Form.Item label="Are you a veteran?" name="eeo_is_veteran">
							<Radio.Group className="vertical-radio-group">
								<Radio value={EeoOptions.yes}>Yes</Radio>
								<Radio value={EeoOptions.no}>No</Radio>
								<Radio value={EeoOptions.no_answer}>Prefer not to answer</Radio>
							</Radio.Group>
						</Form.Item>
					</Col>
					<Col xs={24} lg={12}>
						<Form.Item label="Are you a member of the LGBTQ community?" name="eeo_is_lgbtq">
							<Radio.Group className="vertical-radio-group">
								<Radio value={EeoOptions.yes}>Yes</Radio>
								<Radio value={EeoOptions.no}>No</Radio>
								<Radio value={EeoOptions.no_answer}>Prefer not to answer</Radio>
							</Radio.Group>
						</Form.Item>
					</Col>
					<Col xs={24} lg={12}>
						<Form.Item label="Are you disabled?" name="eeo_is_disabled">
							<Radio.Group className="vertical-radio-group">
								<Radio value={EeoOptions.yes}>Yes</Radio>
								<Radio value={EeoOptions.no}>No</Radio>
								<Radio value={EeoOptions.no_answer}>Prefer not to answer</Radio>
							</Radio.Group>
						</Form.Item>
					</Col>
				</Row>
			</Col>
		</Row>
	)
}

export default EEOInfo
